import React from 'react'
import { Button } from '@atd/rui-base.mui.button'
import { FormControlLabel } from '@atd/rui-base.mui.form-control-label'
import { Radio } from '@atd/rui-base.mui.radio'
import { RadioGroup } from '@atd/rui-base.mui.radio-group'
import ValidatedTextField from '../commonComponents/validatedTextField'

import ResponsiveDialog from '../commonComponents/responsiveDialog'
import { DialogActions } from '@atd/rui-base.mui.dialog-actions'
import { DialogContent } from '@atd/rui-base.mui.dialog-content'
import DialogHeader from '../commonComponents/dialogHeader'

import { mixEntryModeFromDdi } from '../lib/ddiConversions'

import './productConfigStyles.css'

class MixReview extends React.Component {
    static defaultProps = {
        data: {
            id: -1,
            name: '',
            carrierId: null,
            carrierQuantity: 0,
            carrierDisplayQuantity: 0,
            userDisplayUnit: 'gal/ac',
            mixIngredients: [],
            ddiId: 1,
        },
        disabled: true,
    }

    state = {
        ...this.props.data,
        entryMode: mixEntryModeFromDdi(this.props.data.ddiId),
        open: true,
    }

    renderIngredient = (data, i) => {
        if (!data.ingredient) data.ingredient = {name: ''}

        return (
            <div className="mixFlex" name="mixIngredientRow" key={data.id + ' ' + data.ingredientId + data.userDisplayUnit}>
                <ValidatedTextField
                    label="Ingredient"
                    className="selectFieldInline"
                    value={data.ingredient.name}
                    name="ingredientSelect"
                    disabled={this.props.disabled}
                />
                <ValidatedTextField
                    label={this.props.mode === 'rateMode' ? 'Rate' : 'Amount'}
                    defaultValue={data.displayQuantity}
                    className="flexSmall"
                    name="displayQuantity"
                    disabled={this.props.disabled}
                />
                <ValidatedTextField
                    className="unitSelectionInline"
                    value={data.userDisplayUnit}
                    disabled={this.props.disabled}
                    name="displayUnit"
                />
            </div>
        )
    }
    getCarrierSection = () => {
        if (this.state.carrier || this.state.carrierId) {
            return this.renderCarrierLine()
        }

        return this.renderNoCarrierInfo()
    }

    renderNoCarrierInfo = () => {

        return (
            <div className="mixFlex" name="noCarrierSection">
                <div style={{paddingBottom: '4px'}}>{`Mix Units: `}</div>
                <ValidatedTextField
                    className="unitSelectionInline"
                    value={this.state.userDisplayUnit}
                    disabled={this.props.disabled}
                    name="mixUnitSelect"
                />
            </div>
        )
    }
    renderCarrierLine = () => {
        let name = ''
        if (this.state.carrier) {
            name = this.state.carrier.name
        }

        return (
            <div className="mixFlex" name="carrierSection">
                <ValidatedTextField
                    label={'Carrier'}
                    className="selectFieldInline"
                    value={name}
                    style={{top: '0px'}}
                    name="carrierSelect"
                    disabled={this.props.disabled}
                />
                <ValidatedTextField
                    label={this.state.entryMode === 'rateMode' ? 'Mix Rate' : 'Volume'}
                    value={this.state.carrierDisplayQuantity}
                    name="carrierDisplayQuantity"
                    className="flexSmall"
                    disabled={this.props.disabled}
                />
                <ValidatedTextField
                    className="unitSelectionInline"
                    value={this.state.userDisplayUnit}
                    onChange={this.handleUserDisplayUnit}
                    disabled={this.props.disabled}
                    name="carrierUnits"
                />
            </div>
        )
    }
    requestClose = (onComplete) => {
        this.exitCallback = onComplete
        this.setState({open: false})
    }
    handleClose = () => {
        this.requestClose(this.props.onClose)
    }
    renderDialogActions = () => {
        return [
            <Button key="close" variant="contained" color="primary" onClick={this.handleClose}>Close</Button>,
        ]
    }

    render() {
        const ingredientList = this.state.mixIngredients.map(this.renderIngredient)
        const dialogActions = this.renderDialogActions()
        const carrierSection = this.getCarrierSection()

        return (
            <ResponsiveDialog
                open={this.state.open}
                onClose={(_, reason) => { if (reason !== 'backdropClick') this.handleClose() }}
                TransitionProps={{onExited: () => { if (this.exitCallback) this.exitCallback() }}}
                PaperProps={{className: 'wodialog'}}
                fullWidth
            >
                <DialogHeader onClose={this.handleClose}>Mix Information</DialogHeader>
                <DialogContent>
                    <RadioGroup
                        row
                        name="entryMode"
                        value={this.state.entryMode}
                    >
                        <FormControlLabel
                            value="rateMode"
                            label="Rate"
                            control={<Radio name="rateEntryMode" disabled={this.props.disabled}/>}
                        />
                        <FormControlLabel
                            value="qtyMode"
                            label="Quantity"
                            control={<Radio name="QuantityEntryMode" disabled={this.props.disabled}/>}
                        />
                    </RadioGroup>
                    <ValidatedTextField
                        label="Mix Name"
                        fullWidth={true}
                        value={this.state.name}
                        name="name"
                        disabled={this.props.disabled}
                    />
                    {carrierSection}
                    <div style={{marginTop: '20px'}}>{ingredientList}</div>
                </DialogContent>
                <DialogActions>{dialogActions}</DialogActions>
            </ResponsiveDialog>
        )
    }
}
export default (MixReview)
